import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

type Props = {};

export default function EmptyRowsRenderer({}: Props) {
  return (
    <div
      className="px-30 text-center fw-bold text-22 text-light-1"
      style={{
        gridColumn: '1/-1',
        height: 200,
        lineHeight: '200px',
        width: 'calc(100vw - 300px)',
      }}
    >
      <FontAwesomeIcon icon={faSearch} className="mr-10" />
      No data found
    </div>
  );
}
